import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { LogService } from 'src/app/core/service/log/logservice';
import { CookieService } from 'ngx-cookie-service';
import { offlineService } from 'src/app/core/service/notification/Notification.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  passregex = '(?=.*)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%?=*&]).{8,10}';
  emailRegex = '[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$';

  // type="admin";
  value3: string;
  showPassword: boolean;
  loginForm: FormGroup;
  submitted = false;
  disableBtn: boolean = false;

  constructor(
    private fb: FormBuilder,
    private logService: LogService,
    private router: Router,
    private messageService: MessageService,
    private cookieService: CookieService,
    private offlineNotify: offlineService
  ) {}

  ngOnInit(): void {
    this.disableBtn = false;
    this.formInit();
  }
  formInit(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(this.emailRegex)]],
      password: ['', [Validators.required]],
      staySignedIn: [false],
    });
  }
  get f() {
    return this.loginForm.controls;
  }
  // Login Method
  onLogin(): void {
    this.submitted = true;
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }
    this.disableBtn = true;
    this.logService.login(this.loginForm.value).subscribe(
      (res) => {
        if (res.data.firstTimeLogin == true) {
          this.messageService.clear();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message,
            life: 10000,
          });
          sessionStorage.setItem('userId', JSON.stringify(res.data.id));
          setTimeout(() => {
            this.router.navigateByUrl('/reset-password');
          }, 500);
        }
        if (
          res.data.companyType == 'admin' &&
          res.data.firstTimeLogin == false
        ) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message,
            life: 10000,
          });
          sessionStorage.setItem('res', JSON.stringify(res));
          sessionStorage.setItem('licence', JSON.stringify(res.data.licence));
          console.log(res);
          let id = {
            id: res.data.id,
          };
          let check = this.offlineNotify.emit('addUser', id);
          sessionStorage.setItem('reconnectId', JSON.stringify(res.data.id));
          console.log(check, 'coooo');

          let expiryTimer = res.data.expiryHrsMs;
          // res.data.expiryHrsMs
          this.logService.autoLogout(expiryTimer);
          sessionStorage.setItem(
            'ExpiryTime',
            JSON.stringify(res.data.expiryTimeMS)
          );
          this.cookieService.set(
            'accessToken',
            JSON.stringify(res.data.accessToken)
          );
          this.cookieService.set('isUserLogged', JSON.stringify(true));
          sessionStorage.setItem('isUserLogged', JSON.stringify(true));
          sessionStorage.setItem('isUserLogged', JSON.stringify(true));
          setTimeout(() => {
            this.router.navigateByUrl('/sub/Dashboard');
          }, 500);
        } else if (res.data.licence == null || '') {
          this.router.navigateByUrl('/login');
        }
        if (
          (res.data.licence == 'standard' ||
            res.data.licence == 'superior' ||
            res.data.licence == 'premium') &&
          res.data.firstTimeLogin == false
        ) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message,
            life: 10000,
          });
          sessionStorage.setItem('res', JSON.stringify(res));
          sessionStorage.setItem('licence', JSON.stringify(res.data.licence));
          sessionStorage.setItem('userDetails', JSON.stringify(res));
          console.log(res);
          let id = {
            id: res.data.id,
          };
          let check = this.offlineNotify.emit('addUser', id);
          sessionStorage.setItem('reconnectId', JSON.stringify(res.data.id));
          console.log(check, 'coooo');

          let expiryTimer = res.data.expiryHrsMs;
          // res.data.expiryHrsMs
          this.logService.autoLogout(expiryTimer);
          sessionStorage.setItem(
            'ExpiryTime',
            JSON.stringify(res.data.expiryTimeMS)
          );
          this.cookieService.set(
            'accessToken',
            JSON.stringify(res.data.accessToken)
          );
          this.cookieService.set('isUserLogged', JSON.stringify(true));
          sessionStorage.setItem('isUserLogged', JSON.stringify(true));
          sessionStorage.setItem('isUserLogged', JSON.stringify(true));
          setTimeout(() => {
            this.router.navigateByUrl('/sub/Dashboard');
          }, 500);
        }
      },
      (error) => {}
    );
    setInterval(() => {
      this.disableBtn = false;
    }, 5000);
  }

  toggleFieldTextType() {
    this.showPassword = !this.showPassword;
  }

  modeChange() {
    if (environment.mode == 'offline') {
      this.router.navigateByUrl('/account-info');
    } else {
      this.router.navigateByUrl('/forget-password');
    }
  }
}
